angular.module('ics')

    .factory('FSPThirdPartyLispsService', function ($http) {

        return {

            getThirdPartyLispsList: function (fspId, firebaseTokenId, visitorId) {

                var req = {
                    method: 'GET',
                    url: `/api/fsp_third_party_lisp_list/${fspId}`,
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000
                };

                return $http(req);

            },

            createThirdPartyLisp: function (fspId, lisps, client_administered, contact_person, attachments, firebaseTokenId, visitorId) {

                const req = {
                    method: 'POST',
                    url: '/api/fsp_third_party_lisp/',
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000,
                    data: {
                        fsp: fspId,
                        lisps: lisps,
                        client_administered: client_administered,
                        contact_person: contact_person,
                        attachments: attachments || []
                    }
                };

                return $http(req);

            },

            editThirdPartyLisp: function (fspThirdPartyLispId, lisps, client_administered, contact_person, attachments, firebaseTokenId, visitorId) {

                const req = {
                    method: 'PUT',
                    url: `/api/fsp_third_party_lisp/${fspThirdPartyLispId}`,
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000,
                    data: {
                        lisps: lisps,
                        client_administered: client_administered,
                        contact_person: contact_person,
                        attachments: attachments || []
                    }
                };

                return $http(req);

            },

            deleteThirdPartyLisp: function (fspThirdPartyLispId, firebaseTokenId, visitorId) {

                const req = {
                    method: 'DELETE',
                    url: `/api/fsp_third_party_lisp/${fspThirdPartyLispId}`,
                    headers: {
                    'x-firebase-token': firebaseTokenId,
                    'Content-Type': 'application/json',
                    'VisitorId': visitorId || getCookie("ics-visitor-id"),
                    'TwoFAAuthorizationToken': getCookie("ics-2fa-auth-token")
                },
                    timeout: 8000
                };

                return $http(req);


            },


        }

    });
